import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IntlService } from '@progress/kendo-angular-intl';
import { IReportFilterControl } from 'src/app/models';
import { Helpers } from 'src/app/helpers';
import { LoggingService, CoreService, PortalService } from 'src/app/services';
import { IPortalConfig } from 'src/app/models';


@Component({
    selector: 'medpt-report-datepicker',
    templateUrl: './date.component.html',
    styleUrls: ['./date.component.scss'],
    standalone: false
})
export class DateComponent implements OnInit {
  @Input() field!: IReportFilterControl;
  @Input() isMedPoint!: boolean;
  @Input() form!: FormGroup;
  @Output() filterChangeData = new EventEmitter<any>();
  minDate!: Date;
  maxDate: Date = new Date();
  portalInfo: IPortalConfig;
  constructor(public intl: IntlService,
    private loggingService: LoggingService,    
    private coreService: CoreService,
    private portalService: PortalService,) { this.portalInfo = this.portalService.portalConfiguation?.value; }

  ngOnInit(): void {
    this.getStudyPortalCreationDate(<string>this.portalInfo.SponsorName, <number>this.portalInfo.PortalID);
    
    
  }
  onDateChange(value: any) {
    if (Helpers.isNullOrUndefined(value) || value == ""){
      this.form.controls[this.field.controlName].setValue("");
      this.filterChangeData.emit(); //filter for SafetyReport Grid
    }
    else{
      this.form.controls[this.field.controlName].setValue(value);
      this.filterChangeData.emit(); //filter for SafetyReport Grid
    }
  }

  getStudyPortalCreationDate(sponsor: string, portalId: number) {    
    this.loggingService.Info(
      `<MedPoint.WebApp.TriPort.ReportFilters.dateComponent.getStudyPortalCreationDate> begins.`
    );
    this.coreService
      .getStudyPortalCreationDate(sponsor, portalId)
      .then((response: any) => {
        this.minDate = new Date(response);
      })
      .catch((err) => {
        this.loggingService.Error(
          `<MedPoint.WebApp.TriPort.ReportFilters.dateComponent.getStudyPortalCreationDate> Failed with message=${JSON.stringify(err)}`
        );        
      })
      .finally(() => {
        this.loggingService.Info(
          `<MedPoint.WebApp.TriPort.ReportFilters.dateComponent.getStudyPortalCreationDate> ends.`
        );
      });
  }
  
}
